import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BasketInfoComponent } from './elements/basket-info/basket-info.component';
import { DeviceInfoComponent } from './elements/device-info/device-info.component';
import { DeviceShortInfoComponent } from './elements/device-short-info/device-short-info.component';
import { FeatureListComponent } from './elements/feature-list/feature-list.component';
import { FeatureListItemComponent } from './elements/feature-list/feature-list-item/feature-list-item.component';
import { FeatureQuoteListComponent } from './elements/feature-quote-list/feature-quote-list.component';
import { FeatureQuoteListItemComponent } from './elements/feature-quote-list/feature-quote-list-item/feature-quote-list-item.component';
import { TruckListComponent } from './elements/truck-list/truck-list.component';
import { TruckListItemComponent } from './elements/truck-list/truck-list-item/truck-list-item.component';
import { ReactiveFormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { UiModule } from '@kion/ui';
import { LazyLoadImageModule } from 'ng-lazyload-image';
import { MarkdownModule } from 'ngx-markdown';
import { RoleMapDialogComponent } from './dialogs/role-map-dialog/role-map-dialog.component';

@NgModule({
  imports: [
    CommonModule,
    ReactiveFormsModule,
    TranslateModule,
    UiModule,
    LazyLoadImageModule,
    MarkdownModule
  ],
  exports: [
    DeviceInfoComponent,
    FeatureListComponent,
    TruckListComponent,
    BasketInfoComponent,
    DeviceShortInfoComponent,
    FeatureQuoteListComponent
  ],
  declarations: [
    BasketInfoComponent,
    DeviceInfoComponent,
    DeviceShortInfoComponent,
    FeatureListComponent,
    FeatureListItemComponent,
    FeatureQuoteListComponent,
    FeatureQuoteListItemComponent,
    TruckListComponent,
    TruckListItemComponent,
    RoleMapDialogComponent
  ]
})
export class FsUiModule {}
